import { render, staticRenderFns } from "./StepsListItem.vue?vue&type=template&id=905bc880&scoped=true&"
import script from "./StepsListItem.vue?vue&type=script&lang=js&"
export * from "./StepsListItem.vue?vue&type=script&lang=js&"
import style0 from "./StepsListItem.vue?vue&type=style&index=0&id=905bc880&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "905bc880",
  null
  
)

export default component.exports